var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Carousel/CarouselContent.js",
  _this = this;
import React from 'react';
import { Button, Text, Grid, Row, Column } from '../..';
import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
var ImageContainer = withTheme(styled.div.withConfig({
  displayName: "CarouselContent__ImageContainer",
  componentId: "sc-1abvdjo-0"
})(["", ""], function (_ref) {
  var mobileImage = _ref.mobileImage,
    desktopImage = _ref.desktopImage,
    coreTheme = _ref.coreTheme;
  return css(["display:flex;background-position:center center;background-size:cover;background-image:url(", ");height:480px;align-items:center;@media (max-width:", "){align-items:flex-start;justify-content:center;background-image:url(", ");height:550px;}"], desktopImage, coreTheme.brk_xs, mobileImage);
}));
var Wrapper = withTheme(styled.div.withConfig({
  displayName: "CarouselContent__Wrapper",
  componentId: "sc-1abvdjo-1"
})(["display:flex;flex-direction:column;align-items:flex-start;gap:16px;", ""], function (_ref2) {
  var coreTheme = _ref2.coreTheme,
    position = _ref2.position;
  return css(["@media (max-width:", "){text-align:center;align-items:center;}text-align:", ";align-items:", ";"], coreTheme.brk_xs, position === 'center' ? 'center' : 'unset', position === 'center' ? 'center' : 'flex-start');
}));
var CarouselContent = function CarouselContent(_ref3) {
  var desktopImage = _ref3.desktopImage,
    mobileImage = _ref3.mobileImage,
    title = _ref3.title,
    body = _ref3.body,
    buttonText = _ref3.buttonText,
    onClick = _ref3.onClick,
    position = _ref3.position,
    titleTag = _ref3.titleTag,
    inverse = _ref3.inverse;
  return /*#__PURE__*/React.createElement(ImageContainer, {
    position: position,
    desktopImage: desktopImage,
    mobileImage: mobileImage,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Row, {
    reverse: position === 'right',
    center: position === 'center' ? 'xs' : '',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Column, {
    xs: 12,
    md: 6,
    lg: 6,
    xl: 6,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Wrapper, {
    position: position,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 13
    }
  }, title ? /*#__PURE__*/React.createElement(Text, {
    type: "bannerTitle",
    tag: titleTag,
    color: inverse ? 'white' : 'inherit',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 17
    }
  }, title) : null, body ? /*#__PURE__*/React.createElement(Text, {
    type: "body",
    color: inverse ? 'white' : 'inherit',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 17
    }
  }, body) : null, buttonText ? /*#__PURE__*/React.createElement(Button, {
    text: buttonText,
    onClick: onClick,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 17
    }
  }) : null)))));
};
CarouselContent.displayName = 'CarouselContent';
CarouselContent.defaultProps = {
  titleTag: 'h2',
  position: 'left',
  inverse: false,
  body: '',
  buttonText: '',
  mobileImage: '',
  onClick: null,
  title: ''
};
export default CarouselContent;